import PointActivityContent from "./PointActivityContent";

export default PointActivityContent;